class DeliverySaverSubscriptionDetailController {
    $onInit() {
        this.isAnnualPlan = this.plan && this.plan.BillingFrequencyMonths === 12;
    }
}

const DeliverySaverSubscriptionDetailComponentDefinition = {
    controller: DeliverySaverSubscriptionDetailController,
    template: require('./delivery-saver-subscription-detail.component.html').trim(),
    bindings: {
        plan: '<',
        subscription: '<',
        shortTitle: '<',
    },
};

module.exports = {
    DeliverySaverSubscriptionDetailController,
    DeliverySaverSubscriptionDetailComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/subscriptiondetail/delivery-saver-subscription-detail.component.js